import type { CountryPhoneData } from '~/core/ports/entities/phone';

export const countriesPhoneDataList: CountryPhoneData[] = [
	{
		name: 'Brasil',
		code: '+55',
		ddi: 'BR',
		flag: '/flags/br.svg',
		mask: '(##) #####-####'
	},
	{
		name: 'Afghanistan',
		code: '+93',
		ddi: 'AF',
		flag: '/flags/af.svg',
		mask: '##-###-####'
	},
	{
		name: 'Aland Islands',
		code: '+358',
		ddi: 'AX',
		flag: '/flags/ax.svg',
		mask: '(###) ###-##-##'
	},
	{
		name: 'Albania',
		code: '+355',
		ddi: 'AL',
		flag: '/flags/al.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Algeria',
		code: '+213',
		ddi: 'DZ',
		flag: '/flags/dz.svg',
		mask: '##-###-####'
	},
	{
		name: 'American Samoa',
		code: '+1',
		ddi: 'AS',
		flag: '/flags/as.svg',
		mask: '(684) ###-####'
	},
	{
		name: 'Andorra',
		code: '+376',
		ddi: 'AD',
		flag: '/flags/ad.svg',
		mask: '###-###'
	},
	{
		name: 'Angola',
		code: '+244',
		ddi: 'AO',
		flag: '/flags/ao.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Anguilla',
		code: '+1',
		ddi: 'AI',
		flag: '/flags/ai.svg',
		mask: '(264) ###-####'
	},
	{
		name: 'Antarctica',
		code: '+672',
		ddi: 'AQ',
		flag: '/flags/aq.svg',
		mask: '1##-###'
	},
	{
		name: 'Antigua and Barbuda',
		code: '+1',
		ddi: 'AG',
		flag: '/flags/ag.svg',
		mask: '(268) ###-####'
	},
	{
		name: 'Argentina',
		code: '+54',
		ddi: 'AR',
		flag: '/flags/ar.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Armenia',
		code: '+374',
		ddi: 'AM',
		flag: '/flags/am.svg',
		mask: '##-###-###'
	},
	{
		name: 'Aruba',
		code: '+297',
		ddi: 'AW',
		flag: '/flags/aw.svg',
		mask: '###-####'
	},
	{
		name: 'Ascension Island',
		code: '+247',
		ddi: 'AC',
		flag: '/flags/sh.svg',
		mask: '####'
	},
	{
		name: 'Australia',
		code: '+61',
		ddi: 'AU',
		flag: '/flags/au.svg',
		mask: '#-####-####'
	},
	{
		name: 'Austria',
		code: '+43',
		ddi: 'AT',
		flag: '/flags/at.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Azerbaijan',
		code: '+994',
		ddi: 'AZ',
		flag: '/flags/az.svg',
		mask: '##-###-##-##'
	},
	{
		name: 'Bahamas',
		code: '+1',
		ddi: 'BS',
		flag: '/flags/bs.svg',
		mask: '(242) ###-####'
	},
	{
		name: 'Bahrain',
		code: '+973',
		ddi: 'BH',
		flag: '/flags/bh.svg',
		mask: '####-####'
	},
	{
		name: 'Bangladesh',
		code: '+880',
		ddi: 'BD',
		flag: '/flags/bd.svg',
		mask: '1###-######'
	},
	{
		name: 'Barbados',
		code: '+1',
		ddi: 'BB',
		flag: '/flags/bb.svg',
		mask: '(246) ###-####'
	},
	{
		name: 'Belarus',
		code: '+375',
		ddi: 'BY',
		flag: '/flags/by.svg',
		mask: '(##) ###-##-##'
	},
	{
		name: 'Belgium',
		code: '+32',
		ddi: 'BE',
		flag: '/flags/be.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Belize',
		code: '+501',
		ddi: 'BZ',
		flag: '/flags/bz.svg',
		mask: '###-####'
	},
	{
		name: 'Benin',
		code: '+229',
		ddi: 'BJ',
		flag: '/flags/bj.svg',
		mask: '##-##-####'
	},
	{
		name: 'Bermuda',
		code: '+1',
		ddi: 'BM',
		flag: '/flags/bm.svg',
		mask: '(441) ###-####'
	},
	{
		name: 'Bhutan',
		code: '+975',
		ddi: 'BT',
		flag: '/flags/bt.svg',
		mask: ['17-###-###', '77-###-###', '#-###-###']
	},
	{
		name: 'Bolivia',
		code: '+591',
		ddi: 'BO',
		flag: '/flags/bo.svg',
		mask: '#-###-####'
	},
	{
		name: 'Bosnia and Herzegovina',
		code: '+387',
		ddi: 'BA',
		flag: '/flags/ba.svg',
		mask: ['##-####', '##-#####']
	},
	{
		name: 'Botswana',
		code: '+267',
		ddi: 'BW',
		flag: '/flags/bw.svg',
		mask: '##-###-###'
	},
	{
		name: 'British Indian Ocean Territory',
		code: '+246',
		ddi: 'IO',
		flag: '/flags/io.svg',
		mask: '###-####'
	},
	{
		name: 'Brunei Darussalam',
		code: '+673',
		ddi: 'BN',
		flag: '/flags/bn.svg',
		mask: '###-####'
	},
	{
		name: 'Bulgaria',
		code: '+359',
		ddi: 'BG',
		flag: '/flags/bg.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Burkina Faso',
		code: '+226',
		ddi: 'BF',
		flag: '/flags/bf.svg',
		mask: '##-##-####'
	},
	{
		name: 'Burundi',
		code: '+257',
		ddi: 'BI',
		flag: '/flags/bi.svg',
		mask: '##-##-####'
	},
	{
		name: 'Cambodia',
		code: '+855',
		ddi: 'KH',
		flag: '/flags/kh.svg',
		mask: '##-###-###'
	},
	{
		name: 'Cameroon',
		code: '+237',
		ddi: 'CM',
		flag: '/flags/cm.svg',
		mask: '####-####'
	},
	{
		name: 'Canada',
		code: '+1',
		ddi: 'CA',
		flag: '/flags/ca.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Cape Verde',
		code: '+238',
		ddi: 'CV',
		flag: '/flags/cv.svg',
		mask: '(###) ##-##'
	},
	{
		name: 'Cayman Islands',
		code: '+1',
		ddi: 'KY',
		flag: '/flags/ky.svg',
		mask: '(345) ###-####'
	},
	{
		name: 'Central African Republic',
		code: '+236',
		ddi: 'CF',
		flag: '/flags/cf.svg',
		mask: '##-##-####'
	},
	{
		name: 'Chad',
		code: '+235',
		ddi: 'TD',
		flag: '/flags/td.svg',
		mask: '##-##-##-##'
	},
	{
		name: 'Chile',
		code: '+56',
		ddi: 'CL',
		flag: '/flags/cl.svg',
		mask: '#-####-####'
	},
	{
		name: 'China',
		code: '+86',
		ddi: 'CN',
		flag: '/flags/cn.svg',
		mask: ['(###) ####-###', '(###) ####-####', '##-#####-#####']
	},
	{
		name: 'Christmas Island',
		code: '+61',
		ddi: 'CX',
		flag: '/flags/cx.svg',
		mask: '#-####-####'
	},
	{
		name: 'Cocos (Keeling)  Islands',
		code: '+61',
		ddi: 'CC',
		flag: '/flags/cc.svg',
		mask: '#-####-####'
	},
	{
		name: 'Colombia',
		code: '+57',
		ddi: 'CO',
		flag: '/flags/co.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Comoros',
		code: '+269',
		ddi: 'KM',
		flag: '/flags/km.svg',
		mask: '##-#####'
	},
	{
		name: 'Congo',
		code: '+242',
		ddi: 'CG',
		flag: '/flags/cg.svg',
		mask: '##-#####'
	},
	{
		name: 'Cook Islands',
		code: '+682',
		ddi: 'CK',
		flag: '/flags/ck.svg',
		mask: '##-###'
	},
	{
		name: 'Costa Rica',
		code: '+506',
		ddi: 'CR',
		flag: '/flags/cr.svg',
		mask: '####-####'
	},
	{
		name: 'Croatia',
		code: '+385',
		ddi: 'HR',
		flag: '/flags/hr.svg',
		mask: '##-###-###'
	},
	{
		name: 'Cuba',
		code: '+53',
		ddi: 'CU',
		flag: '/flags/cu.svg',
		mask: '#-###-####'
	},
	{
		name: 'Cyprus',
		code: '+357',
		ddi: 'CY',
		flag: '/flags/cy.svg',
		mask: '##-###-###'
	},
	{
		name: 'Czech Republic',
		code: '+420',
		ddi: 'CZ',
		flag: '/flags/cz.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Democratic Republic of the Congo',
		code: '+243',
		ddi: 'CD',
		flag: '/flags/cd.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Denmark',
		code: '+45',
		ddi: 'DK',
		flag: '/flags/dk.svg',
		mask: '##-##-##-##'
	},
	{
		name: 'Djibouti',
		code: '+253',
		ddi: 'DJ',
		flag: '/flags/dj.svg',
		mask: '##-##-##-##'
	},
	{
		name: 'Dominica',
		code: '+1',
		ddi: 'DM',
		flag: '/flags/dm.svg',
		mask: '(767) ###-####'
	},
	{
		name: 'Dominican Republic',
		code: '+1',
		ddi: 'DO',
		flag: '/flags/do.svg',
		mask: ['(809) ###-####', '(829) ###-####', '(849) ###-####']
	},
	{
		name: 'Ecuador',
		code: '+593',
		ddi: 'EC',
		flag: '/flags/ec.svg',
		mask: ['#-###-####', '##-###-####']
	},
	{
		name: 'Egypt',
		code: '+20',
		ddi: 'EG',
		flag: '/flags/eg.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'El Salvador',
		code: '+503',
		ddi: 'SV',
		flag: '/flags/sv.svg',
		mask: '##-##-####'
	},
	{
		name: 'Equatorial Guinea',
		code: '+240',
		ddi: 'GQ',
		flag: '/flags/gq.svg',
		mask: '##-###-####'
	},
	{
		name: 'Eritrea',
		code: '+291',
		ddi: 'ER',
		flag: '/flags/er.svg',
		mask: '#-###-###'
	},
	{
		name: 'Estonia',
		code: '+372',
		ddi: 'EE',
		flag: '/flags/ee.svg',
		mask: ['###-####', '####-####']
	},
	{
		name: 'Eswatini',
		code: '+268',
		ddi: 'SZ',
		flag: '/flags/sz.svg',
		mask: '##-##-####'
	},
	{
		name: 'Ethiopia',
		code: '+251',
		ddi: 'ET',
		flag: '/flags/et.svg',
		mask: '##-###-####'
	},
	{
		name: 'Falkland Islands (Malvinas) ',
		code: '+500',
		ddi: 'FK',
		flag: '/flags/fk.svg',
		mask: '#####'
	},
	{
		name: 'Faroe Islands',
		code: '+298',
		ddi: 'FO',
		flag: '/flags/fo.svg',
		mask: '###-###'
	},
	{
		name: 'Fiji',
		code: '+679',
		ddi: 'FJ',
		flag: '/flags/fj.svg',
		mask: '##-#####'
	},
	{
		name: 'Finland',
		code: '+358',
		ddi: 'FI',
		flag: '/flags/fi.svg',
		mask: '(###) ###-##-##'
	},
	{
		name: 'France',
		code: '+33',
		ddi: 'FR',
		flag: '/flags/fr.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'French Guiana',
		code: '+594',
		ddi: 'GF',
		flag: '/flags/gf.svg',
		mask: '#####-####'
	},
	{
		name: 'French Polynesia',
		code: '+689',
		ddi: 'PF',
		flag: '/flags/pf.svg',
		mask: '##-##-##'
	},
	{
		name: 'Gabon',
		code: '+241',
		ddi: 'GA',
		flag: '/flags/ga.svg',
		mask: '#-##-##-##'
	},
	{
		name: 'Gambia',
		code: '+220',
		ddi: 'GM',
		flag: '/flags/gm.svg',
		mask: '(###) ##-##'
	},
	{
		name: 'Georgia',
		code: '+995',
		ddi: 'GE',
		flag: '/flags/ge.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Germany',
		code: '+49',
		ddi: 'DE',
		flag: '/flags/de.svg',
		mask: [
			'###-###',
			'(###) ##-##',
			'(###) ##-###',
			'(###) ##-####',
			'(###) ###-####',
			'(####) ###-####'
		]
	},
	{
		name: 'Ghana',
		code: '+233',
		ddi: 'GH',
		flag: '/flags/gh.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Gibraltar',
		code: '+350',
		ddi: 'GI',
		flag: '/flags/gi.svg',
		mask: '###-#####'
	},
	{
		name: 'Greece',
		code: '+30',
		ddi: 'GR',
		flag: '/flags/gr.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Greenland',
		code: '+299',
		ddi: 'GL',
		flag: '/flags/gl.svg',
		mask: '##-##-##'
	},
	{
		name: 'Grenada',
		code: '+1',
		ddi: 'GD',
		flag: '/flags/gd.svg',
		mask: '(473) ###-####'
	},
	{
		name: 'Guadeloupe',
		code: '+590',
		ddi: 'GP',
		flag: '/flags/gp.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Guam',
		code: '+1',
		ddi: 'GU',
		flag: '/flags/gu.svg',
		mask: '(671) ###-####'
	},
	{
		name: 'Guatemala',
		code: '+502',
		ddi: 'GT',
		flag: '/flags/gt.svg',
		mask: '#-###-####'
	},
	{
		name: 'Guernsey',
		code: '+44',
		ddi: 'GG',
		flag: '/flags/gg.svg',
		mask: '(####) ######'
	},
	{
		name: 'Guinea',
		code: '+224',
		ddi: 'GN',
		flag: '/flags/gn.svg',
		mask: '##-###-###'
	},
	{
		name: 'Guinea-Bissau',
		code: '+245',
		ddi: 'GW',
		flag: '/flags/gw.svg',
		mask: '#-######'
	},
	{
		name: 'Guyana',
		code: '+592',
		ddi: 'GY',
		flag: '/flags/gy.svg',
		mask: '###-####'
	},
	{
		name: 'Haiti',
		code: '+509',
		ddi: 'HT',
		flag: '/flags/ht.svg',
		mask: '##-##-####'
	},
	{
		name: 'Holy See (Vatican City State) ',
		code: '+39',
		ddi: 'VA',
		flag: '/flags/va.svg',
		mask: '06 698#####'
	},
	{
		name: 'Honduras',
		code: '+504',
		ddi: 'HN',
		flag: '/flags/hn.svg',
		mask: '####-####'
	},
	{
		name: 'Hong Kong',
		code: '+852',
		ddi: 'HK',
		flag: '/flags/hk.svg',
		mask: '####-####'
	},
	{
		name: 'Hungary',
		code: '+36',
		ddi: 'HU',
		flag: '/flags/hu.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Iceland',
		code: '+354',
		ddi: 'IS',
		flag: '/flags/is.svg',
		mask: '###-####'
	},
	{
		name: 'India',
		code: '+91',
		ddi: 'IN',
		flag: '/flags/in.svg',
		mask: '(####) ###-###'
	},
	{
		name: 'Indonesia',
		code: '+62',
		ddi: 'ID',
		flag: '/flags/id.svg',
		mask: [
			'##-###-##',
			'##-###-###',
			'##-###-####',
			'(8##) ###-###',
			'(8##) ###-##-###'
		]
	},
	{
		name: 'Iran',
		code: '+98',
		ddi: 'IR',
		flag: '/flags/ir.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Iraq',
		code: '+924',
		ddi: 'IQ',
		flag: '/flags/iq.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Ireland',
		code: '+353',
		ddi: 'IE',
		flag: '/flags/ie.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Isle of Man',
		code: '+44',
		ddi: 'IM',
		flag: '/flags/im.svg',
		mask: '(####) ######'
	},
	{
		name: 'Israel',
		code: '+972',
		ddi: 'IL',
		flag: '/flags/il.svg',
		mask: ['#-###-####', '5#-###-####']
	},
	{
		name: 'Italy',
		code: '+39',
		ddi: 'IT',
		flag: '/flags/it.svg',
		mask: '(###) ####-###'
	},
	{
		name: 'Ivory Coast / Cote d Ivoire',
		code: '+225',
		ddi: 'CI',
		flag: '/flags/ci.svg',
		mask: '##-###-###'
	},
	{
		name: 'Jamaica',
		code: '+1',
		ddi: 'JM',
		flag: '/flags/jm.svg',
		mask: '(876) ###-####'
	},
	{
		name: 'Japan',
		code: '+81',
		ddi: 'JP',
		flag: '/flags/jp.svg',
		mask: ['(###) ###-###', '##-####-####']
	},
	{
		name: 'Jersey',
		code: '+44',
		ddi: 'JE',
		flag: '/flags/je.svg',
		mask: '(####) ####-######'
	},
	{
		name: 'Jordan',
		code: '+962',
		ddi: 'JO',
		flag: '/flags/jo.svg',
		mask: '#-####-####'
	},
	{
		name: 'Kazakhstan',
		code: '+77',
		ddi: 'KZ',
		flag: '/flags/kz.svg',
		mask: ['(6##) ###-##-##', '(7##) ###-##-##']
	},
	{
		name: 'Kenya',
		code: '+254',
		ddi: 'KE',
		flag: '/flags/ke.svg',
		mask: '###-######'
	},
	{
		name: 'Kiribati',
		code: '+686',
		ddi: 'KI',
		flag: '/flags/ki.svg',
		mask: '##-###'
	},
	{
		name: 'Korea, Democratic Peoples Republic of Korea',
		code: '+850',
		ddi: 'KP',
		flag: '/flags/kp.svg',
		mask: [
			'###-###',
			'####-####',
			'##-###-###',
			'###-####-###',
			'191-###-####',
			'####-#############'
		]
	},
	{
		name: 'Korea, Republic of South Korea',
		code: '+82',
		ddi: 'KR',
		flag: '/flags/kr.svg',
		mask: '##-###-####'
	},
	{
		name: 'Kosovo',
		code: '+383',
		ddi: 'XK',
		flag: '/flags/xk.svg',
		mask: ['##-###-###', '###-###-###']
	},
	{
		name: 'Kuwait',
		code: '+965',
		ddi: 'KW',
		flag: '/flags/kw.svg',
		mask: '####-####'
	},
	{
		name: 'Kyrgyzstan',
		code: '+996',
		ddi: 'KG',
		flag: '/flags/kg.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Laos',
		code: '+856',
		ddi: 'LA',
		flag: '/flags/la.svg',
		mask: ['##-###-###', '(20##) ###-###']
	},
	{
		name: 'Latvia',
		code: '+371',
		ddi: 'LV',
		flag: '/flags/lv.svg',
		mask: '##-###-###'
	},
	{
		name: 'Lebanon',
		code: '+961',
		ddi: 'LB',
		flag: '/flags/lb.svg',
		mask: ['#-###-###', '##-###-###']
	},
	{
		name: 'Lesotho',
		code: '+266',
		ddi: 'LS',
		flag: '/flags/ls.svg',
		mask: '#-###-####'
	},
	{
		name: 'Liberia',
		code: '+231',
		ddi: 'LR',
		flag: '/flags/lr.svg',
		mask: '##-###-###'
	},
	{
		name: 'Libya',
		code: '+218',
		ddi: 'LY',
		flag: '/flags/ly.svg',
		mask: ['##-###-###', '21-###-####']
	},
	{
		name: 'Liechtenstein',
		code: '+423',
		ddi: 'LI',
		flag: '/flags/li.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Lithuania',
		code: '+370',
		ddi: 'LT',
		flag: '/flags/lt.svg',
		mask: '(###) ##-###'
	},
	{
		name: 'Luxembourg',
		code: '+352',
		ddi: 'LU',
		flag: '/flags/lu.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Macau',
		code: '+853',
		ddi: 'MO',
		flag: '/flags/mo.svg',
		mask: '####-####'
	},
	{
		name: 'Madagascar',
		code: '+261',
		ddi: 'MG',
		flag: '/flags/mg.svg',
		mask: '##-##-#####'
	},
	{
		name: 'Malawi',
		code: '+265',
		ddi: 'MW',
		flag: '/flags/mw.svg',
		mask: ['1-###-###', '#-####-####']
	},
	{
		name: 'Malaysia',
		code: '+60',
		ddi: 'MY',
		flag: '/flags/my.svg',
		mask: ['#-###-###', '##-###-###', '(###) ###-###', '##-###-####']
	},
	{
		name: 'Maldives',
		code: '+960',
		ddi: 'MV',
		flag: '/flags/mv.svg',
		mask: '###-####'
	},
	{
		name: 'Mali',
		code: '+223',
		ddi: 'ML',
		flag: '/flags/ml.svg',
		mask: '##-##-####'
	},
	{
		name: 'Malta',
		code: '+356',
		ddi: 'MT',
		flag: '/flags/mt.svg',
		mask: '####-####'
	},
	{
		name: 'Marshall Islands',
		code: '+692',
		ddi: 'MH',
		flag: '/flags/mh.svg',
		mask: '###-####'
	},
	{
		name: 'Martinique',
		code: '+596',
		ddi: 'MQ',
		flag: '/flags/mq.svg',
		mask: '(###) ##-##-##'
	},
	{
		name: 'Mauritania',
		code: '+222',
		ddi: 'MR',
		flag: '/flags/mr.svg',
		mask: '##-##-####'
	},
	{
		name: 'Mauritius',
		code: '+230',
		ddi: 'MU',
		flag: '/flags/mu.svg',
		mask: '###-####'
	},
	{
		name: 'Mayotte',
		code: '+262',
		ddi: 'YT',
		flag: '/flags/yt.svg',
		mask: '#####-####'
	},
	{
		name: 'Mexico',
		code: '+52',
		ddi: 'MX',
		flag: '/flags/mx.svg',
		mask: ['##-##-####', '(###) ###-####']
	},
	{
		name: 'Micronesia, Federated States of Micronesia',
		code: '+691',
		ddi: 'FM',
		flag: '/flags/fm.svg',
		mask: '###-####'
	},
	{
		name: 'Moldova',
		code: '+373',
		ddi: 'MD',
		flag: '/flags/md.svg',
		mask: '####-####'
	},
	{
		name: 'Monaco',
		code: '+377',
		ddi: 'MC',
		flag: '/flags/mc.svg',
		mask: ['##-###-###', '(###) ###-###']
	},
	{
		name: 'Mongolia',
		code: '+976',
		ddi: 'MN',
		flag: '/flags/mn.svg',
		mask: '##-##-####'
	},
	{
		name: 'Montenegro',
		code: '+382',
		ddi: 'ME',
		flag: '/flags/me.svg',
		mask: '##-###-###'
	},
	{
		name: 'Montserrat',
		code: '+1',
		ddi: 'MS',
		flag: '/flags/ms.svg',
		mask: '(664) ###-####'
	},
	{
		name: 'Morocco',
		code: '+212',
		ddi: 'MA',
		flag: '/flags/ma.svg',
		mask: '##-####-###'
	},
	{
		name: 'Mozambique',
		code: '+258',
		ddi: 'MZ',
		flag: '/flags/mz.svg',
		mask: '##-###-###'
	},
	{
		name: 'Myanmar',
		code: '+95',
		ddi: 'MM',
		flag: '/flags/mm.svg',
		mask: ['###-###', '#-###-###', '##-###-###']
	},
	{
		name: 'Namibia',
		code: '+224',
		ddi: 'NA',
		flag: '/flags/na.svg',
		mask: '##-###-####'
	},
	{
		name: 'Nauru',
		code: '+674',
		ddi: 'NR',
		flag: '/flags/nr.svg',
		mask: '###-####'
	},
	{
		name: 'Nepal',
		code: '+977',
		ddi: 'NP',
		flag: '/flags/np.svg',
		mask: '##-###-###'
	},
	{
		name: 'Netherlands',
		code: '+31',
		ddi: 'NL',
		flag: '/flags/nl.svg',
		mask: '##-###-####'
	},
	{
		name: 'Netherlands Antilles',
		code: '+599',
		ddi: 'AN',
		flag: '/flags/an.svg',
		mask: ['###-####', '9###-####']
	},
	{
		name: 'New Caledonia',
		code: '+687',
		ddi: 'NC',
		flag: '/flags/nc.svg',
		mask: '##-####'
	},
	{
		name: 'New Zealand',
		code: '+24',
		ddi: 'NZ',
		flag: '/flags/nz.svg',
		mask: ['#-###-###', '(###) ###-###', '(###) ###-####']
	},
	{
		name: 'Nicaragua',
		code: '+505',
		ddi: 'NI',
		flag: '/flags/ni.svg',
		mask: '####-####'
	},
	{
		name: 'Niger',
		code: '+227',
		ddi: 'NE',
		flag: '/flags/ne.svg',
		mask: '##-##-####'
	},
	{
		name: 'Nigeria',
		code: '+234',
		ddi: 'NG',
		flag: '/flags/ng.svg',
		mask: ['##-###-##', '##-###-###', '(###) ###-####']
	},
	{
		name: 'Niue',
		code: '+683',
		ddi: 'NU',
		flag: '/flags/nu.svg',
		mask: '####'
	},
	{
		name: 'Norfolk Island',
		code: '+672',
		ddi: 'NF',
		flag: '/flags/nf.svg',
		mask: '3##-###'
	},
	{
		name: 'North Macedonia',
		code: '+389',
		ddi: 'MK',
		flag: '/flags/mk.svg',
		mask: '##-###-###'
	},
	{
		name: 'Northern Mariana Islands',
		code: '+1',
		ddi: 'MP',
		flag: '/flags/mp.svg',
		mask: '(670) ###-####'
	},
	{
		name: 'Norway',
		code: '+47',
		ddi: 'NO',
		flag: '/flags/no.svg',
		mask: '(###) ##-###'
	},
	{
		name: 'Oman',
		code: '+968',
		ddi: 'OM',
		flag: '/flags/om.svg',
		mask: '##-###-###'
	},
	{
		name: 'Pakistan',
		code: '+92',
		ddi: 'PK',
		flag: '/flags/pk.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Palau',
		code: '+680',
		ddi: 'PW',
		flag: '/flags/pw.svg',
		mask: '###-####'
	},
	{
		name: 'Palestine',
		code: '+970',
		ddi: 'PS',
		flag: '/flags/ps.svg',
		mask: '##-###-####'
	},
	{
		name: 'Panama',
		code: '+507',
		ddi: 'PA',
		flag: '/flags/pa.svg',
		mask: '###-####'
	},
	{
		name: 'Papua New Guinea',
		code: '+675',
		ddi: 'PG',
		flag: '/flags/pg.svg',
		mask: '(###) ##-###'
	},
	{
		name: 'Paraguay',
		code: '+595',
		ddi: 'PY',
		flag: '/flags/py.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Peru',
		code: '+51',
		ddi: 'PE',
		flag: '/flags/pe.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Philippines',
		code: '+63',
		ddi: 'PH',
		flag: '/flags/ph.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Pitcairn',
		code: '+870',
		ddi: 'PN',
		flag: '/flags/pn.svg',
		mask: '###-###-###'
	},
	{
		name: 'Poland',
		code: '+48',
		ddi: 'PL',
		flag: '/flags/pl.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Portugal',
		code: '+351',
		ddi: 'PT',
		flag: '/flags/pt.svg',
		mask: '##-###-####'
	},
	{
		name: 'Puerto Rico',
		code: '+1',
		ddi: 'PR',
		flag: '/flags/pr.svg',
		mask: ['(787)  ### ####', '(939)  ### ####']
	},
	{
		name: 'Qatar',
		code: '+974',
		ddi: 'QA',
		flag: '/flags/qa.svg',
		mask: '####-####'
	},
	{
		name: 'Reunion',
		code: '+262',
		ddi: 'RE',
		flag: '/flags/re.svg',
		mask: '#####-####'
	},
	{
		name: 'Romania',
		code: '+40',
		ddi: 'RO',
		flag: '/flags/ro.svg',
		mask: '##-###-####'
	},
	{
		name: 'Russia',
		code: '+7',
		ddi: 'RU',
		flag: '/flags/ru.svg',
		mask: '(###) ###-##-##'
	},
	{
		name: 'Rwanda',
		code: '+250',
		ddi: 'RW',
		flag: '/flags/rw.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Saint Barthelemy',
		code: '+590',
		ddi: 'BL',
		flag: '/flags/bl.svg',
		mask: '###-##-##-##'
	},
	{
		name: 'Saint Helena, Ascension and Tristan Da Cunha',
		code: '+290',
		ddi: 'SH',
		flag: '/flags/sh.svg',
		mask: '####'
	},
	{
		name: 'Saint Kitts and Nevis',
		code: '+1',
		ddi: 'KN',
		flag: '/flags/kn.svg',
		mask: '(869) ###-####'
	},
	{
		name: 'Saint Lucia',
		code: '+1',
		ddi: 'LC',
		flag: '/flags/lc.svg',
		mask: '(758) ###-####'
	},
	{
		name: 'Saint Martin',
		code: '+590',
		ddi: 'MF',
		flag: '/flags/mf.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Saint Pierre and Miquelon',
		code: '+508',
		ddi: 'PM',
		flag: '/flags/pm.svg',
		mask: '##-####'
	},
	{
		name: 'Saint Vincent and the Grenadines',
		code: '+1',
		ddi: 'VC',
		flag: '/flags/vc.svg',
		mask: '(784) ###-####'
	},
	{
		name: 'Samoa',
		code: '+685',
		ddi: 'WS',
		flag: '/flags/ws.svg',
		mask: '##-####'
	},
	{
		name: 'San Marino',
		code: '+378',
		ddi: 'SM',
		flag: '/flags/sm.svg',
		mask: '####-######'
	},
	{
		name: 'Sao Tome and Principe',
		code: '+239',
		ddi: 'ST',
		flag: '/flags/st.svg',
		mask: '##-#####'
	},
	{
		name: 'Saudi Arabia',
		code: '+966',
		ddi: 'SA',
		flag: '/flags/sa.svg',
		mask: ['#-###-####', '5#-####-####']
	},
	{
		name: 'Senegal',
		code: '+221',
		ddi: 'SN',
		flag: '/flags/sn.svg',
		mask: '##-###-####'
	},
	{
		name: 'Serbia',
		code: '+381',
		ddi: 'RS',
		flag: '/flags/rs.svg',
		mask: '##-###-####'
	},
	{
		name: 'Seychelles',
		code: '+248',
		ddi: 'SC',
		flag: '/flags/sc.svg',
		mask: '#-###-###'
	},
	{
		name: 'Sierra Leone',
		code: '+232',
		ddi: 'SL',
		flag: '/flags/sl.svg',
		mask: '##-######'
	},
	{
		name: 'Singapore',
		code: '+65',
		ddi: 'SG',
		flag: '/flags/sg.svg',
		mask: '####-####'
	},
	{
		name: 'Sint Maarten',
		code: '+1',
		ddi: 'SX',
		flag: '/flags/sx.svg',
		mask: '(721) ###-####'
	},
	{
		name: 'Slovakia',
		code: '+421',
		ddi: 'SK',
		flag: '/flags/sk.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Slovenia',
		code: '+386',
		ddi: 'SI',
		flag: '/flags/si.svg',
		mask: '##-###-###'
	},
	{
		name: 'Solomon Islands',
		code: '+677',
		ddi: 'SB',
		flag: '/flags/sb.svg',
		mask: ['#####', '###-####']
	},
	{
		name: 'Somalia',
		code: '+252',
		ddi: 'SO',
		flag: '/flags/so.svg',
		mask: ['#-###-###', '##-###-###']
	},
	{
		name: 'South Africa',
		code: '+27',
		ddi: 'ZA',
		flag: '/flags/za.svg',
		mask: '##-###-####'
	},
	{
		name: 'South Georgia and the South Sandwich Islands',
		code: '+500',
		ddi: 'GS',
		flag: '/flags/gs.svg',
		mask: '#####'
	},
	{
		name: 'South Sudan',
		code: '+211',
		ddi: 'SS',
		flag: '/flags/ss.svg',
		mask: '##-###-####'
	},
	{
		name: 'Spain',
		code: '+34',
		ddi: 'ES',
		flag: '/flags/es.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Sri Lanka',
		code: '+94',
		ddi: 'LK',
		flag: '/flags/lk.svg',
		mask: '##-###-####'
	},
	{
		name: 'Sudan',
		code: '+249',
		ddi: 'SD',
		flag: '/flags/sd.svg',
		mask: '##-###-####'
	},
	{
		name: 'Suriname',
		code: '+597',
		ddi: 'SR',
		flag: '/flags/sr.svg',
		mask: ['###-###', '###-####']
	},
	{
		name: 'Svalbard and Jan Mayen',
		code: '+47',
		ddi: 'SJ',
		flag: '/flags/sj.svg',
		mask: '(###) ##-###'
	},
	{
		name: 'Sweden',
		code: '+46',
		ddi: 'SE',
		flag: '/flags/se.svg',
		mask: '##-###-####'
	},
	{
		name: 'Switzerland',
		code: '+41',
		ddi: 'CH',
		flag: '/flags/ch.svg',
		mask: '##-###-####'
	},
	{
		name: 'Syrian Arab Republic',
		code: '+963',
		ddi: 'SY',
		flag: '/flags/sy.svg',
		mask: '##-####-###'
	},
	{
		name: 'Taiwan',
		code: '+886',
		ddi: 'TW',
		flag: '/flags/tw.svg',
		mask: ['####-####', '#-####-####']
	},
	{
		name: 'Tajikistan',
		code: '+992',
		ddi: 'TJ',
		flag: '/flags/tj.svg',
		mask: '##-###-####'
	},
	{
		name: 'Tanzania, United Republic of Tanzania',
		code: '+255',
		ddi: 'TZ',
		flag: '/flags/tz.svg',
		mask: '##-###-####'
	},
	{
		name: 'Thailand',
		code: '+66',
		ddi: 'TH',
		flag: '/flags/th.svg',
		mask: ['##-###-###', '##-###-####']
	},
	{
		name: 'Timor-Leste',
		code: '+670',
		ddi: 'TL',
		flag: '/flags/tl.svg',
		mask: ['###-####', '77#-#####', '78#-#####']
	},
	{
		name: 'Togo',
		code: '+228',
		ddi: 'TG',
		flag: '/flags/tg.svg',
		mask: '##-###-###'
	},
	{
		name: 'Tokelau',
		code: '+690',
		ddi: 'TK',
		flag: '/flags/tk.svg',
		mask: '####'
	},
	{
		name: 'Tonga',
		code: '+676',
		ddi: 'TO',
		flag: '/flags/to.svg',
		mask: '#####'
	},
	{
		name: 'Trinidad and Tobago',
		code: '+1',
		ddi: 'TT',
		flag: '/flags/tt.svg',
		mask: '(868) ###-####'
	},
	{
		name: 'Tunisia',
		code: '+216',
		ddi: 'TN',
		flag: '/flags/tn.svg',
		mask: '##-###-###'
	},
	{
		name: 'Turkey',
		code: '+90',
		ddi: 'TR',
		flag: '/flags/tr.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Turkmenistan',
		code: '+993',
		ddi: 'TM',
		flag: '/flags/tm.svg',
		mask: '#-###-####'
	},
	{
		name: 'Turks and Caicos Islands',
		code: '+1',
		ddi: 'TC',
		flag: '/flags/tc.svg',
		mask: '(249) ###-###'
	},
	{
		name: 'Tuvalu',
		code: '+688',
		ddi: 'TV',
		flag: '/flags/tv.svg',
		mask: ['2####', '90####']
	},
	{
		name: 'Uganda',
		code: '+256',
		ddi: 'UG',
		flag: '/flags/ug.svg',
		mask: '(###) ###-###'
	},
	{
		name: 'Ukraine',
		code: '+380',
		ddi: 'UA',
		flag: '/flags/ua.svg',
		mask: '(##) ###-##-##'
	},
	{
		name: 'United Arab Emirates',
		code: '+971',
		ddi: 'AE',
		flag: '/flags/ae.svg',
		mask: ['#-###-####', '5#-###-####']
	},
	{
		name: 'United Kingdom',
		code: '+44',
		ddi: 'GB',
		flag: '/flags/gb.svg',
		mask: '##-####-####'
	},
	{
		name: 'United States',
		code: '+1',
		ddi: 'US',
		flag: '/flags/us.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Uruguay',
		code: '+598',
		ddi: 'UY',
		flag: '/flags/uy.svg',
		mask: '#-###-##-##'
	},
	{
		name: 'Uzbekistan',
		code: '+998',
		ddi: 'UZ',
		flag: '/flags/uz.svg',
		mask: '##-###-####'
	},
	{
		name: 'Vanuatu',
		code: '+678',
		ddi: 'VU',
		flag: '/flags/vu.svg',
		mask: ['#####', '##-#####']
	},
	{
		name: 'Venezuela, Bolivarian Republic of Venezuela',
		code: '+58',
		ddi: 'VE',
		flag: '/flags/ve.svg',
		mask: '(###) ###-####'
	},
	{
		name: 'Vietnam',
		code: '+84',
		ddi: 'VN',
		flag: '/flags/vn.svg',
		mask: ['##-####-###', '(###) ####-###']
	},
	{
		name: 'Virgin Islands, British',
		code: '+1',
		ddi: 'VG',
		flag: '/flags/vg.svg',
		mask: '(284) ###-####'
	},
	{
		name: 'Virgin Islands, U.S.',
		code: '+1',
		ddi: 'VI',
		flag: '/flags/vi.svg',
		mask: '(340) ###-####'
	},
	{
		name: 'Wallis and Futuna',
		code: '+681',
		ddi: 'WF',
		flag: '/flags/wf.svg',
		mask: '##-####'
	},
	{
		name: 'Yemen',
		code: '+967',
		ddi: 'YE',
		flag: '/flags/ye.svg',
		mask: ['#-###-###', '##-###-###', '###-###-###']
	},
	{
		name: 'Zambia',
		code: '+260',
		ddi: 'ZM',
		flag: '/flags/zm.svg',
		mask: '##-###-####'
	},
	{
		name: 'Zimbabwe',
		code: '+263',
		ddi: 'ZW',
		flag: '/flags/zw.svg',
		mask: '#-######'
	}
];

export const countriesPhoneDataByDDI: Record<string, CountryPhoneData> =
	countriesPhoneDataList.reduce(
		(acc, country) => ({
			...acc,
			[country.ddi]: country
		}),
		{}
	);

Object.freeze(countriesPhoneDataByDDI);
Object.freeze(countriesPhoneDataList);
